const FUNNEL_STAGES = [
  { key: 'New',           label: 'New',           color: 'bg-blue-400' },
  { key: 'Contacted',     label: 'Contacted',     color: 'bg-purple-400' },
  { key: 'Follow-up',     label: 'Follow-up',     color: 'bg-yellow-400' },
  { key: 'Call Booked',   label: 'Call Booked',   color: 'bg-cyan-500' },
  { key: 'Proposal Sent', label: 'Proposal Sent', color: 'bg-orange-400' },
  { key: 'Negotiating',   label: 'Negotiating',   color: 'bg-amber-500' },
  { key: 'Won',           label: 'Won',           color: 'bg-emerald-500' },
];

export default function ConversionFunnel({ statusCounts = {} }) {
  const top = statusCounts['New'] || 0;

  return (
    <div className="bg-white border border-zinc-200 rounded-lg p-4">
      <h2 className="text-sm font-semibold text-zinc-700 mb-4">Stage Conversion Funnel</h2>

      {top === 0 ? (
        <p className="text-sm text-zinc-400 py-4 text-center">No lead data yet.</p>
      ) : (
        <div className="space-y-1.5">
          {FUNNEL_STAGES.map((stage, i) => {
            const count = statusCounts[stage.key] || 0;
            const prev  = i === 0 ? top : (statusCounts[FUNNEL_STAGES[i - 1].key] || 0);
            const pctOfTop  = top > 0 ? (count / top) * 100 : 0;
            const convRate  = prev > 0 && i > 0 ? Math.round((count / prev) * 100) : null;

            return (
              <div key={stage.key} className="group">
                <div className="flex items-center gap-3">
                  {/* Bar */}
                  <div className="flex-1 relative h-8 bg-zinc-100 rounded overflow-hidden">
                    <div
                      className={`absolute left-0 top-0 h-full ${stage.color} transition-all duration-500 rounded`}
                      style={{ width: `${Math.max(pctOfTop, count > 0 ? 2 : 0)}%` }}
                    />
                    <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-xs font-medium text-zinc-700 z-10">
                      {stage.label}
                    </span>
                  </div>

                  {/* Count */}
                  <span className="text-sm font-semibold text-zinc-800 w-8 text-right">{count}</span>

                  {/* Conversion rate */}
                  <span className="text-xs w-14 text-right">
                    {convRate !== null ? (
                      <span className={convRate >= 50 ? 'text-emerald-600' : convRate >= 25 ? 'text-amber-600' : 'text-red-500'}>
                        {convRate}%
                      </span>
                    ) : (
                      <span className="text-zinc-300">—</span>
                    )}
                  </span>
                </div>

                {/* Drop arrow between stages */}
                {i < FUNNEL_STAGES.length - 1 && (
                  <div className="flex justify-end pr-14">
                    <div className="w-px h-1.5 bg-zinc-200" />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      <div className="mt-3 pt-3 border-t border-zinc-100 flex items-center justify-between text-xs text-zinc-400">
        <span>Overall win rate</span>
        <span className="font-semibold text-zinc-700">
          {top > 0 ? `${Math.round(((statusCounts['Won'] || 0) / top) * 100)}%` : '—'}
        </span>
      </div>
    </div>
  );
}
